import './index.css'
import { MapComponent } from './MapComponent'
import { LanguageSwitcher } from './components/LanguageSwitcher'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

export function App() {
  const { i18n } = useTranslation()
  const isRTL = i18n.language === 'ar'

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language
  }, [i18n.language, isRTL])

  return (
    <div className="w-full h-full" style={{ height: '100dvh' }}>
      {/* Language Switcher */}
      <LanguageSwitcher />

      {/* Full Screen Map */}
      <MapComponent />
    </div>
  )
}

export default App
